import { render } from "./RequestToChangeEbmSettings.vue?vue&type=template&id=bae99908&scoped=true"
import script from "./RequestToChangeEbmSettings.vue?vue&type=script&lang=js"
export * from "./RequestToChangeEbmSettings.vue?vue&type=script&lang=js"

import "./RequestToChangeEbmSettings.vue?vue&type=style&index=0&id=bae99908&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae99908"]])

export default __exports__